/**
 * DragPreviewLayer – Benutzerdefinierte Drag-Vorschau
 * 
 * Zeigt eine schwebende Karte mit Dokumentenname und KI-Empfehlung,
 * die dem Cursor beim Ziehen folgt.
 */

import { useDragLayer } from 'react-dnd';
import { DND_TYPES } from '@/lib/dndTypes';
import { FileText, Sparkles } from 'lucide-react';

function getItemStyles(currentOffset) {
  if (!currentOffset) return { display: 'none' };
  const { x, y } = currentOffset;
  return {
    transform: `translate(${x}px, ${y}px)`,
    pointerEvents: 'none',
  };
}

export default function DragPreviewLayer() {
  const { isDragging, item, currentOffset } = useDragLayer((monitor) => ({
    isDragging: monitor.isDragging(),
    item: monitor.getItem(),
    currentOffset: monitor.getSourceClientOffset(),
  }));

  if (!isDragging || !item?.dokument) return null;

  const dok = item.dokument;
  const ki = item.kiEmpfehlung;
  const klientName = ki?.gefundener_klient
    ? `${ki.gefundener_klient.vorname || ''} ${ki.gefundener_klient.nachname || ''}`.trim()
    : ki?.ki_empfehlung?.klient
      ? `${ki.ki_empfehlung.klient.vorname || ''} ${ki.ki_empfehlung.klient.nachname || ''}`.trim()
      : null;

  return (
    <div
      className="fixed inset-0 z-[9999] pointer-events-none"
      data-testid="drag-preview-layer"
    >
      <div style={getItemStyles(currentOffset)}>
        <div className="bg-white rounded-lg shadow-2xl border border-blue-200 px-3 py-2 w-64 opacity-95">
          <div className="flex items-center gap-2">
            <FileText className="w-4 h-4 text-blue-500 shrink-0" />
            <span className="text-sm font-medium text-slate-800 truncate">
              {dok.dateiname || dok.titel || 'Dokument'}
            </span>
          </div>
          {klientName && (
            <div className="flex items-center gap-1.5 mt-1.5 pl-6">
              <Sparkles className="w-3 h-3 text-indigo-500 shrink-0" />
              <span className="text-xs text-indigo-600 truncate">
                Zeo: {klientName}
              </span>
            </div>
          )}
          <p className="text-[10px] text-slate-400 mt-1 pl-6">
            Auf einen Tab ziehen zum Zuordnen
          </p>
        </div>
      </div>
    </div>
  );
}
